<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-input v-model="query['item.no']" placeholder="placeholder.itemNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['item.name']" placeholder="placeholder.itemName" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['lot.no']" placeholder="placeholder.lotNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['location.no']" placeholder="placeholder.location" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-button-group style="margin-left: 8px">
          <vxe-button content="button.query" icon="vxe-icon-search" status="primary" @click="refresh"/>
          <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
        </vxe-button-group>
      </template>
      <template #extra>
        <vxe-select v-model="batchEdit.maintenanceWay" :options="maintenanceWays" placeholder="placeholder.maintenanceMeasure" @change="batchEditMaintenanceWay"/>
        <vxe-input v-model="batchEdit.maintainAdvice" placeholder="placeholder.maintenanceAdvice" @keydown.native.enter="batchEditMaintainAdvice"/>
        <vxe-button-group style="margin-left: 8px">
          <vxe-button content="button.maintain" icon="vxe-icon-add" status="primary" @click="maintain"/>
          <vxe-button content="button.delete" icon="vxe-icon-delete" status="danger" @click="remove"/>
          <vxe-button content="button.maintenancePlanGeneration" icon="vxe-icon-add" status="warning" @click="generate"/>
        </vxe-button-group>
      </template>
      <vxe-table ref="table" :data="data" :edit-config="{}" :edit-rules="editRules" :loading="loading" keep-source>
        <vxe-column fixed="left" type="checkbox" width="40"/>
        <vxe-column field="item.no" title="business.label.itemNo" width="80"/>
        <vxe-column field="item.name" title="business.label.itemName" width="200"/>
        <vxe-column field="pack.specification" title="business.label.specification" width="150"/>
        <vxe-column field="pack.factor" title="business.label.factor" width="50"/>
        <vxe-column field="pack.uom" title="business.label.uom" width="60"/>
        <vxe-column field="lot.no" title="business.label.lotNo" width="110"/>
        <vxe-column field="lot.productionDate" title="business.label.productionDate" width="100"/>
        <vxe-column field="lot.validUntil" title="business.label.validUntil" width="100"/>
        <vxe-column field="lot.manufacturer" title="business.label.manufacturer" width="150"/>
        <vxe-column field="location.no" title="business.label.location" width="110"/>
        <vxe-column field="storageRoom.name" title="business.label.storageRoom" width="100"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="maintenance.important" fixed="right" title="business.label.important" width="60"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:inventoryStates}" field="maintenance.inventoryState" fixed="right" title="business.label.inventoryState" width="70"/>
        <vxe-column field="maintenance.inventoryQuantity" fixed="right" title="business.label.invQuantity" width="80"/>
        <vxe-column :edit-render="{name:'VxeNumberInput',props:{min:1}}" field="maintenance.quantity" fixed="right" title="span.maintenanceQuantity" width="120"/>
        <vxe-column :edit-render="{name:'VxeSelect',options:maintenanceWays}" field="maintenance.maintenanceWay" fixed="right" title="span.maintenanceMeasure" width="150"/>
        <vxe-column :edit-render="{name:'VxeInput'}" field="maintenance.notes" fixed="right" title="span.maintenanceAdvice" width="150"/>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :loading="loading" :page-size="size" :total="contentSize" @page-change="pageChange"/>
      </template>
    </vxe-card>
  </div>
</template>

<script>
import { del, findAll, post } from '@/api/Api'
import api from '@/api'
import Vue from 'vue'
import { OPERATOR } from '@/store/mutation-types'
import { getEnums } from '@/utils/util'

export default {
  name: 'MaintenancePlan',
  data() {
    return {
      loading: false,
      operator: Vue.ls.get(OPERATOR),
      data: [],
      query: {
        'item.no': '',
        'item.name': '',
        'lot.no': '',
        'location.no': '',
        executed: false
      },
      inventoryStates: [],
      maintenanceWays: [],
      batchEdit: {
        maintenanceWay: undefined,
        maintainAdvice: ''
      },
      editRules: {
        'maintenance.quantity': [{ required: true, min: 1, type: 'number', message: '养护数量需大于0' }]
      },
      page: 1,
      size: 20,
      contentSize: 0
    }
  },
  created() {
    getEnums('InventoryState').then(result => {
      this.inventoryStates = result
      return getEnums('MaintenanceWay')
    }).then(result => {
      this.maintenanceWays = result
    })
  },
  activated() {
    this.refresh()
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch() {
      this.data = []
      this.loading = true
      findAll('maintenanceFactory', this.query, this.page, this.size).then(res => {
        if (res.success) {
          this.data = res.result
          this.contentSize = res.contentSize
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    reset() {
      this.query = {
        'item.no': '',
        'item.name': '',
        'lot.no': '',
        'location.no': '',
        executed: false
      }
      this.batchEdit = {
        maintenanceWay: undefined,
        maintainAdvice: ''
      }
      this.refresh()
    },
    batchEditMaintenanceWay() {
      const dataSource = [...this.data]
      this.data = []
      this.$nextTick(() => {
        dataSource.forEach(item => {
          item.maintenance.maintenanceWay = this.batchEdit.maintenanceWay
        })
        this.data = dataSource
      })
    },
    batchEditMaintainAdvice() {
      const dataSource = [...this.data]
      this.data = []
      this.$nextTick(() => {
        dataSource.forEach(item => {
          item.maintenance.notes = this.batchEdit.maintainAdvice
        })
        this.data = dataSource
      })
    },
    remove() {
      let selectedRows = this.$refs.table.getCheckboxRecords()
      if (selectedRows.length === 0) {
        return this.$message.warning('请选中需要删除的明细')
      }
      this.loading = true
      del(api.deleteAll, { type: 'maintenanceDeleter' }, { ids: selectedRows.map(item => item.maintenance.id) }).then(res => {
        if (res.success) {
          this.fetch()
          this.$message.success(this.$t('message.deleteSuccess'))
        }
      }).finally(() => this.loading = false)
    },
    async maintain() {
      let selectedRows = this.$refs.table.getCheckboxRecords()
      if (selectedRows.length === 0) {
        return this.$message.warning('请选择需要养护的计划')
      }
      const errMap = await this.$refs.table.validate(true)
      if (errMap) {
        return
      }
      this.loading = true
      let args = []
      selectedRows.forEach(item => {
        let arg = {
          id: item.maintenance.id,
          assessment: 1,
          maintainer: this.operator.name,
          quantity: item.maintenance.quantity,
          maintenanceWay: item.maintenance.maintenanceWay,
          notes: item.maintenance.notes
        }
        args.push(arg)
      })
      post(api.conversionMaintainerExecute, {}, args).then(res => {
        if (res.success) {
          this.fetch()
          this.$message.success(this.$t('message.operationSuccess'))
        }
      }).finally(() => this.loading = false)
    },
    generate() {
      this.loading = true
      post(api.schedulingSchedule.replace('{type}', 'maintenanceGeneration'), {}).then(res => {
        if (res.success) {
          this.fetch()
          this.$message.success(this.$t('message.operationSuccess'))
        }
      }).finally(() => this.loading = false)
    }
  }
}
</script>